import {useEffect} from "react";
import {formatDocumentTitle, SITE_TITLE} from "@/lib/documentTitle";

export function useDocumentTitle(pageTitle?: string | null) {
  useEffect(() => {
    document.title = formatDocumentTitle(pageTitle);
    return () => {
      document.title = SITE_TITLE;
    };
  }, [pageTitle]);
}
